import React from "react";
import useTransitionStore from "../../../../state/transitions";
const Suspension = React.lazy(() => import("./Suspension"));

const SuspensionContainer = () => {
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const SuspensionMode = useTransitionStore((s) => s.SuspensionMode);

  return (
    <group
      position={[0, -0.95, 0]}
      rotation={[0, Math.PI * 1.5, 0]}
      visible={SuspensionMode}
    >
      <Suspension />
    </group>
  );
};

export default SuspensionContainer;
